export default __webpack_public_path__ + "static/media/pear-site.ac58f547.png";